import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction';

const CbMobileLogOut = (props) => {
    const dispatch = useDispatch();
    const history = useHistory()
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const handleLogOut = (event) => {
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/logout`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    dispatch(updateProfileDetailsAction(true,"logout"))
                    localStorage.clear();
                    history.push('/account/login?DPSLogout=true')
                } else {
                    const error = res._ERROR_MESSAGE_;
                }
            })
    };
    return (
        <>
            <p className="c-cos-account-dtails">
                {/* <span>Welcome back, {props && props.userName ? props.userName : profileDetails?.firstName+" "+profileDetails?.lastName}</span> */}
                <span>Welcome back, {props?.userName || profileDetails?.firstName}&nbsp;{profileDetails?.lastName}</span>
                <Link onClick={handleLogOut}>
                    Not {props && props.firstName ? props.firstName : profileDetails?.firstName}? (Logout)
                </Link>
            </p>
        </>
    )
}

export default CbMobileLogOut